export default __webpack_public_path__ + "static/media/graphSensor.6ad93dc8.png";